import { Component } from 'react';

/**
 * Catches render-time errors in the component tree below it.
 * Wrap any page section you want to protect:
 *   <ErrorBoundary><SomePage /></ErrorBoundary>
 */
class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production this is where you'd log to Sentry / etc.
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 py-16 text-center">
        <div className="text-6xl mb-4">⚠️</div>
        <h2 className="text-2xl font-bold text-red-600 mb-3">
          Something went wrong
        </h2>
        <p className="text-gray-500 mb-2 max-w-md">
          An unexpected error occurred while rendering this section.
        </p>
        {process.env.NODE_ENV === 'development' && (
          <pre className="text-left text-sm bg-gray-100 border border-gray-300 rounded p-4 max-w-lg overflow-auto mb-4 text-red-700">
            {this.state.error?.message}
          </pre>
        )}
        <button
          onClick={this.handleReset}
          style={{ background: 'linear-gradient(135deg,#667eea,#764ba2)' }}
          className="mt-2 px-6 py-3 text-white font-semibold rounded-lg shadow-md hover:opacity-90 transition-opacity"
        >
          Try Again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
